import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import Cookies from "js-cookie";

import { actionLogout } from "../../../redux/loginReduser/actionLogout";
import {
  actionRefreshRefreshToken,
  actionRefreshToken,
} from "../../../redux/loginReduser/actionRefreshToken";
import { logoutUserById } from "../../../redux/actions";

import ConfirmationModal from "../../confirmationModal/confirmationModal";
import Burger from "../Burger/Burger";

import styles from "./Header.module.css";

function Header({ isLogin, isMaintenance, handleLogin }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const accessToken = Cookies.get("accessToken");
  const refreshToken = Cookies.get("refreshToken");
  const userId = Cookies.get("userId");

  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [isCheckTokenChanged, setIsCheckTokenChanged] = useState(false);

  const userInfo = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer.userInfo;
  });

  const checkToken = useSelector((state) => {
    const { authLoginReducer } = state;
    return authLoginReducer.authData.checkAccessToken;
  });

  const handleConfirm = () => {
    dispatch(actionLogout());
    dispatch(logoutUserById(userId));
    Cookies.remove("userId");
    Cookies.remove("isAuthorized");
    handleLogin("");
    navigate("login");

    setIsConfirmationModalOpen(false);
  };

  useEffect(() => {
    if (!isLogin || isMaintenance) return;

    if (checkToken === false) {
      dispatch(actionRefreshToken());
    }
  }, [checkToken, isCheckTokenChanged]);

  useEffect(() => {
    setIsCheckTokenChanged(!isCheckTokenChanged);
  }, [checkToken]);

  useEffect(() => {
    const logOut = () => {
      if (userId) {
        dispatch(logoutUserById(userId));
        Cookies.remove("userId");
        Cookies.remove("isAuthorized");
      }
      handleLogin("");
      navigate("login");
    };

    if (
      !refreshToken ||
      (refreshToken && refreshToken === "null") ||
      (accessToken && accessToken === "null")
    ) {
      logOut();
    }
  }, [navigate]);

  useEffect(() => {
    if (!isLogin || isMaintenance) return;

    const intervalRefreshToken = setInterval(
      async () => {
        if (refreshToken) {
          dispatch(actionRefreshRefreshToken());
        }
      },
      1400 * 60 * 1000,
    );

    if (!userId) {
      clearInterval(intervalRefreshToken);
    }

    return () => {
      clearInterval(intervalRefreshToken);
    };
  }, [dispatch, userId, isLogin]);

  return (
    <div
      className={`${styles["header-bg"]} ${
        isLogin ? styles["header-tablet"] : ""
      }`}
    >
      <div className={styles["header-content"]}>
        <div className={styles["left-header-block"]}>
          <img
            alt="gims-logo"
            className={styles["gims-logo"]}
            src="/assets/gims-logo.png"
          ></img>
          <div className={styles["titles-container"]}>
            <h1 className={styles["page-title"]}>
              МИНИСТЕРСТВО ПО ЧРЕЗВЫЧАЙНЫМ СИТУАЦИЯМ РЕСПУБЛИКИ БЕЛАРУСЬ
            </h1>
            <h2 className={styles["page-title-secondary"]}>
              Государственная инспекция по маломерным судам
            </h2>
          </div>
        </div>

        {isLogin && !isMaintenance && (
          <div className={styles["exit-container"]}>
            <Burger />
            <div className={styles["exit"]}>
              <p className={styles["person-text"]}>
                <span>{userInfo?.name}</span>
                <span>{userInfo?.section?.sctName || "—"}</span>
              </p>
              <button
                id="save"
                onClick={() => setIsConfirmationModalOpen(true)}
                className={styles["save-btn"]}
              >
                <span className={styles["search-icon"]}></span>
                <span>ВЫХОД</span>
              </button>
            </div>
          </div>
        )}
      </div>
      <ConfirmationModal
        isOpen={isConfirmationModalOpen}
        title="Подтверждение действия"
        text="Вы уверены, что хотите выйти из системы?"
        textButton="Подтвердить"
        onClose={() => setIsConfirmationModalOpen(false)}
        onConfirm={handleConfirm}
      />
    </div>
  );
}

export default Header;
